import 'slick-carousel';
import 'slick-carousel/slick/slick.css';

$(function() {
    if ($('.testimonials-slider').length === 0) return;

    $('.testimonials-slider').slick({
        slidesToShow: 3,
        centerMode: true,
        centerPadding: '0px',
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Prev" type="button"><i class="fa-solid fa-arrow-left"></i></button>',
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><i class="fa-solid fa-arrow-right"></i></button>',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    centerMode: false,
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 992,
                settings: {
                    centerMode: true,
                    slidesToShow: 1
                }
            },
        ]
    });
});
